const state = {
  loading: true,
  timezone: {
    global: 'UTC',
    console: null
  },
  date_format: {
    global: {
      time: 'short',
      date: 'short',
      calendar: 'gregory'
    },
    console: null
  }
}

const getters = {
  timezoneLoading: state => state.loading,
  timezone: state => state.timezone.console || state.timezone.global,
  date_format: state => state.date_format.console || state.date_format.global
}

const mutations = {
  SET_TIMEZONE_LOADING (state, value) {
    state.loading = value
  },
  SET_TIMEZONE (state, { level, data }) {
    state.timezone[level] = data
  },
  SET_DATE_FORMAT (state, { level, data }) {
    state.date_format[level] = data
  }
}

const actions = {
  setTimezoneLoading ({ commit }, value) {
    commit('SET_TIMEZONE_LOADING', value)
  },

  setTimezone ({ state, commit }, { level, data }) {
    if (!level) {
      level = 'global'
    }
    commit('SET_TIMEZONE', { data, level })
  },
  setDateFormat ({ state, commit }, { level, data }) {
    if (!level) {
      level = 'global'
    }
    commit('SET_DATE_FORMAT', { data, level })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
